import styles from "./cancel_confirmation.module.scss"
import parse from "html-react-parser"
import iconSuccessCheck from "images/icons/icon-success-check-green.svg?raw"

interface Props {
  expirationDate: string
  exploreUrl: string
  tierName: string
}

const CancelConfirmation = ({ expirationDate, exploreUrl, tierName }: Props) => {
  return (
    <div className={styles.cancel_confirmation}>
      <div className={styles.checkmark}>
        {parse(iconSuccessCheck)}
      </div>

      <h1 className="mb2--phone mb2--small-phone">Plan cancelled</h1>

      <p className={styles.description}>
        Your IFTTT {tierName} subscription will end on {expirationDate}. At that time your benefits will end and your
        card will not be charged.
      </p>

      <div className="cancellation-actions cancellation-actions--confirmation">
        <a className="button-primary" href={exploreUrl}>
          Return to home
        </a>
      </div>
    </div>
  )
}

export default CancelConfirmation
